/**
 * Shared formatting helpers.
 */

/**
 * Format a byte count into a human-readable string (e.g. "2.4 MB", "812 KB", "640 B").
 */
export const formatBytes = (bytes?: number | null): string => {
  if (bytes === null || bytes === undefined || Number.isNaN(bytes)) return "-";
  if (bytes <= 0) return "0 B";

  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  const value = bytes / Math.pow(k, i);
  // Bytes are always whole; larger units get one decimal when meaningful.
  const rounded = i === 0 ? Math.round(value) : parseFloat(value.toFixed(1));
  return `${rounded} ${sizes[i]}`;
};

/**
 * Format a timestamp safely. Missing or malformed values return a readable
 * placeholder instead of throwing — date-fns raises "Invalid time value" on a
 * bad Date and that crashes the whole screen.
 */
export const formatDateTime = (
  value?: string | number | Date | null,
  pattern: "datetime" | "date" = "datetime",
  fallback = "Unknown time",
): string => {
  if (!value) return fallback;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return pattern === "date"
    ? date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
    : date.toLocaleString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
};
